<div class="row">
  <div class="col-md-12 mt-4 d-flex">
    <fa-icon [icon]="faTag" size="lg"></fa-icon>
    &nbsp;
    <p class="text-uppercase"><b>Tags</b></p>
  </div>
  <div class="row">
    <div class="col-md-12 mb-4 d-flex flex-wrap">
      <a
        *ngFor="let tag of selectedAuction.article.articleTagList"
        class="me-2 mb-2 tags"
        href="{{languageService.userSelectedLanguage.code}}/tags/{{tag.description.toLowerCase()}}"
        [class.tags-gold]="isMemorabid && !inPreEventStatus"
        [class.tags-marketplace]="!isMemorabid && !inPreEventStatus"
        [class.tags-preEvent]="inPreEventStatus"
      >
        {{ tag.tagTranslatedList[0]?.translatedValue }}
      </a>
    </div>
  </div>
</div>
